import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ModalRef } from '../../abstracts/modal-ref';
import { IModal } from '../../interfaces/modal.interface';
import { DomService } from './dom.service';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    public isOpened$: Observable<boolean>;
    public modalData$: Observable<IModal>;

    private _isOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _modalData$: Subject<IModal> = new Subject<IModal>();

    private pageYOffset: number;
    private hasComponent: boolean;

    private readonly bodyClass = '-modal-open';

    constructor(private domService: DomService) {
        this.isOpened$ = this._isOpened$.asObservable();
        this.modalData$ = this._modalData$.asObservable();
    }

    public openModal(modalData?: IModal): void {
        if (this._isOpened$.getValue()) {
            this.closeModal();
        }
        this.showModal(modalData);
    }

    public openModalWithComponent<ComponentType>(modalData?: IModal): ModalRef<ComponentType> {
        if (this._isOpened$.getValue()) {
            this.closeModal();
        }
        this.hasComponent = true;
        const currentModal: ModalRef<ComponentType> = this.domService.appendComponentTo(
            modalData.component.parentIdRef,
            modalData.component.componentRef,
            modalData.component.config
        );
        this.showModal(modalData);
        return currentModal;
    }

    public closeModal(): void {
        if (this._isOpened$.getValue() === false) {
            return;
        }
        document.body.classList.remove(this.bodyClass);
        if (this.hasComponent) {
            this.domService.removeComponent();
            this.hasComponent = false;
        }
        this._isOpened$.next(false);
        window.scrollTo(0, this.pageYOffset);
        document.body.scrollTop = this.pageYOffset;
    }

    private showModal(modalData: IModal): void {
        this.pageYOffset = window.pageYOffset;
        document.body.classList.add(this.bodyClass);
        this._modalData$.next(modalData);
        this._isOpened$.next(true);
        if (document.getElementById('closeButton')) {
            document.getElementById('closeButton').focus();
        }
    }
}
